import 'widget/components/VehicleExtraCta/VehicleExtraCta.scss';

import React from 'react';
import PropTypes from 'prop-types';

import { LocaleService, WindowProxy } from '@sm360/widget-commons-core-services';
import { AccountService, ModalService, REDIRECTIONS } from '@sm360/widget-commons-general';
import { Vehicle } from '@sm360/widget-commons-vehicle';
import VehicleExtraCtaItemList from 'vdp-used/components/VehicleExtraCta/VehicleExtraCtaItemList/VehicleExtraCtaItemList.jsx';

function handleAuthentication({ redirect = '/' }) {
    const windowProxy = WindowProxy.get();

    if (!AccountService.isAuthenticated()) {
        const LoginModal = ModalService.get('login/SignUpModal');
        LoginModal.addCallbacks({
            onClose: () => {
                if (AccountService.isAuthenticated() && windowProxy) {
                    windowProxy.location.assign(redirect);
                    return true;
                }
                return true;
            },
        });
        LoginModal.open();
    } else if (windowProxy) {
        windowProxy.location.assign(redirect);
    }
}

const VehicleExtraCta = ({ vehicle }) => {
    const ctaData = {
        testDrive: {
            location: 'test.drive',
            default: {
                tagline: LocaleService.t('VDP_USED.EXTRA_CTA.TEST_DRIVE.TAGLINE'),
                button: LocaleService.t('VDP_USED.EXTRA_CTA.TEST_DRIVE.BUTTON'),
            },
            onClick: () => {
                const formURL = REDIRECTIONS[LocaleService.getSimpleLocale()].testDriveForm
                    .replace(/{id}/g, vehicle.vehicleId)
                    .replace(/{make}/g, vehicle.getMake())
                    .replace(/{model}/g, vehicle.getModel())
                    .replace(/{stock}/g, vehicle.stockNumber)
                    .replace(/{year}/g, vehicle.year);

                const windowProxy = WindowProxy.get();
                if (windowProxy) {
                    windowProxy.location.assign(formURL);
                }
            },
        },
        tradeIn: {
            location: 'trade.in',
            default: {
                tagline: LocaleService.t('VDP_USED.EXTRA_CTA.TRADE_IN.TAGLINE'),
                button: LocaleService.t('VDP_USED.EXTRA_CTA.TRADE_IN.BUTTON'),
            },
            onClick: () => {
                handleAuthentication({ redirect: REDIRECTIONS[LocaleService.getSimpleLocale()].tradeIn });
            },
        },
        finance: {
            location: 'finance',
            default: {
                tagline: LocaleService.t('VDP_USED.EXTRA_CTA.FINANCE.TAGLINE'),
                button: LocaleService.t('VDP_USED.EXTRA_CTA.FINANCE.BUTTON'),
            },
            onClick: () => {
                handleAuthentication({ redirect: REDIRECTIONS[LocaleService.getSimpleLocale()].financing });
            },
        },
    };

    return <VehicleExtraCtaItemList ctaData={ctaData} />;
};

VehicleExtraCta.propTypes = {
    vehicle: PropTypes.instanceOf(Vehicle.VehicleModelV25).isRequired,
};

export default VehicleExtraCta;
